module.exports = __webpack_public_path__ + "static/media/016-dental.676d1f1c.svg";